import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import PropTypes from "prop-types";
import { Spin, Button } from "antd";
import styles from "./VisualitzacioParametresCerca.module.css";
import VisualitzacioSelectorPeriode from "./VisualitzacioSelectorPeriode";
import VisualitzacioSelectorEspecie from "./VisualitzacioSelectorEspecie";
import VisualitzacioSelectorFenofase from "./VisualitzacioSelectorFenofase";
import {
  obtenirDadesVisualitzacio,
  obtenirObservacionsVisualitzacio,
  omplirDataSeleccionadaVisualitzacio,
  omplirEspecieFenofaseSeleccionadaVisualitzacio,
  errorConsultaServidor
} from "../../actions";
import {
  getPeticioVisualitzacioEnCurs,
  getIdEspecie,
  getIdFenofase,
  getDataIniciAsMoment,
  getDataFiAsMoment
} from "../../reducers";
import {
  crearNotificacioDatesObligatories,
  crearNotificacioErrorDataActual,
  crearNotificacioEspecieObligatoria,
  crearNotificacioFenofaseObligatoria,
  crearNotificacioSuperaPeriodeMaxim,
  crearNotificacioNoObservacions,
  crearNotificacioParametresNoCanviats
} from "../../utils/notificacio";
import {
  MASCARA_ISO_DIA,
  MASCARA_ISO_HORA,
  formatStringDate
} from "../../utils/dates";
import { convertirTextAMomentLocal } from "../../utils/dates";
import { MAXIM_DIES_PERIODE } from "../../constantsObservacions.js";
import { MISSATGE_SPIN_PARAMETRES_CERCA } from "../../constantsFormularis";
import { mostrarMissatgeError } from "../../utils/gestioErrorsXarxa";

class VisualitzacioParametresCerca extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dataInici: "",
      dataFi: "",
      idEspecie: "",
      idFenofase: ""
    };
  }

  componentDidMount() {
    this.onChangeData();
  }

  paramsCercaDiferents = () => {
    const { dataInici, dataFi, idEspecie, idFenofase } = this.props;
    const dataIniciProps = moment(dataInici).format("DD-MM-YYYY");
    const dataIniciState = moment(this.state.dataInici).format("DD-MM-YYYY");
    const dataFiProps = moment(dataFi).format("DD-MM-YYYY");
    const dataFiState = moment(this.state.dataFi).format("DD-MM-YYYY");

    return (
      dataIniciProps !== dataIniciState ||
      dataFiProps !== dataFiState ||
      this.state.idEspecie !== idEspecie ||
      this.state.idFenofase !== idFenofase
    );
  };

  onFerCerca = () => {
    const { dataInici, dataFi, idEspecie, idFenofase } = this.props;

    if (!dataInici || !dataFi) {
      crearNotificacioDatesObligatories();
      return;
    }

    if (!idEspecie) {
      crearNotificacioEspecieObligatoria();
      return;
    }

    if (!idFenofase) {
      crearNotificacioFenofaseObligatoria();
      return;
    }

    if (!this.paramsCercaDiferents()) {
      crearNotificacioParametresNoCanviats();
      return;
    }

    this.setState({ dataInici: dataInici });
    this.setState({ dataFi: dataFi });
    this.setState({ idEspecie: idEspecie });
    this.setState({ idFenofase: idFenofase });

    if (
      !dataFi.isBetween(
        dataInici,
        dataInici.clone().add(MAXIM_DIES_PERIODE, "days"),
        "minute",
        "[]"
      )
    ) {
      crearNotificacioSuperaPeriodeMaxim(MAXIM_DIES_PERIODE);
      return;
    }

    this.props
      .obtenirObservacionsVisualitzacio(
        dataInici,
        dataFi,
        idEspecie,
        idFenofase
      )
      .then(observacions => {
        this.props.omplirEspecieFenofaseSeleccionadaVisualitzacio(
          idEspecie,
          idFenofase
        );

        const errorXarxa = mostrarMissatgeError(observacions);
        if (errorXarxa) {
          return this.props.errorConsultaServidor(
            errorXarxa.error,
            errorXarxa.missatge
          );
        }

        if (
          !observacions.payload ||
          !Array.isArray(observacions.payload) ||
          observacions.payload.length === 0
        ) {
          crearNotificacioNoObservacions();
        }

        this.props.omplirDataSeleccionadaVisualitzacio(dataInici, idEspecie);
      })
      .catch(error => {
        if (error.message && error.titol) {
          return this.props.errorConsultaServidor(error.titol, error.message);
        }
      });
  };

  onChangeData = () => {
    this.props
      .obtenirDadesVisualitzacio()
      .then(dades => {
        const errorXarxa = mostrarMissatgeError(dades);
        if (errorXarxa) {
          return this.props.errorConsultaServidor(
            errorXarxa.error,
            errorXarxa.missatge
          );
        }
      })
      .catch(error => {
        if (error.message && error.titol) {
          return this.props.errorConsultaServidor(error.titol, error.message);
        }
      });
  };

  render() {
    const { isPeticioVisEnCurs } = this.props;

    const dataActual =
      formatStringDate(new Date().toString(), MASCARA_ISO_DIA) +
      MASCARA_ISO_HORA;
    const dataActualMoment = convertirTextAMomentLocal(dataActual);

    if (!dataActualMoment) {
      crearNotificacioErrorDataActual();
    }

    return (
      <Spin
        spinning={isPeticioVisEnCurs}
        tip={MISSATGE_SPIN_PARAMETRES_CERCA}
        delay={0}
      >
        <div style={{ marginTop: 16, marginLeft: 16 }}>
          <VisualitzacioSelectorPeriode dataActual={dataActualMoment} />
          <VisualitzacioSelectorEspecie />
          <VisualitzacioSelectorFenofase />
          <Button
            type="primary"
            onClick={this.onFerCerca}
            className={styles.selectorPeriodeBoto}
          >
            Cercar
          </Button>
        </div>
      </Spin>
    );
  }
}

VisualitzacioParametresCerca.propTypes = {
  isPeticioVisEnCurs: PropTypes.bool,
  idEspecie: PropTypes.number,
  idFenofase: PropTypes.number,
  obtenirObservacionsVisualitzacio: PropTypes.func.isRequired,
  obtenirDadesVisualitzacio: PropTypes.func.isRequired,
  omplirDataSeleccionadaVisualitzacio: PropTypes.func.isRequired,
  omplirEspecieFenofaseSeleccionadaVisualitzacio: PropTypes.func.isRequired,
  errorConsultaServidor: PropTypes.func
};

const mapStateToProps = state => {
  return {
    isPeticioVisEnCurs: getPeticioVisualitzacioEnCurs(state),
    idEspecie: getIdEspecie(state),
    idFenofase: getIdFenofase(state),
    dataInici: getDataIniciAsMoment(state),
    dataFi: getDataFiAsMoment(state)
  };
};

const mapDispatchToProps = {
  obtenirDadesVisualitzacio,
  obtenirObservacionsVisualitzacio,
  omplirDataSeleccionadaVisualitzacio,
  omplirEspecieFenofaseSeleccionadaVisualitzacio,
  errorConsultaServidor
};

export default connect(mapStateToProps, mapDispatchToProps)(
  VisualitzacioParametresCerca
);
